/**
 * "My Levels" modal: lists the user's saved levels (LevelStore.listUser)
 * and lets them pick one to load.
 */

import * as LevelStore from '../../../editor/LevelStore.js';
import { createModalShell, styleButton } from './modalUtils.js';

export interface MyLevelsController { close(): void }

export interface MyLevelsOptions {
  /** Invoked when the user picks a stored level. The host should
   *  call its loadLevelByData on `entry.data`. The modal will have
   *  closed itself before this fires. */
  onPick: (entry: LevelStore.StoredLevel) => void;
  /** Invoked once when the modal closes for any reason. */
  onClose?: () => void;
}

export function openMyLevelsModal(opts: MyLevelsOptions): MyLevelsController {
  const stored = LevelStore.listUser();
  const shell = createModalShell({
    width: 'min(520px, 92vw)',
    maxHeight: '80vh',
    ...(opts.onClose ? { onClose: opts.onClose } : {}),
  });

  const heading = document.createElement('div');
  heading.textContent = 'My Levels';
  Object.assign(heading.style, { fontWeight: '600', fontSize: '15px' } as Partial<CSSStyleDeclaration>);
  shell.panel.appendChild(heading);

  const list = document.createElement('div');
  Object.assign(list.style, {
    flex: '1', overflowY: 'auto',
    display: 'flex', flexDirection: 'column', gap: '4px',
    maxHeight: '60vh',
  } as Partial<CSSStyleDeclaration>);

  if (stored.length === 0) {
    const empty = document.createElement('div');
    empty.style.opacity = '0.7';
    empty.style.padding = '8px';
    empty.textContent = 'No saved levels yet. Open the editor to create one.';
    list.appendChild(empty);
  } else {
    for (const s of stored) {
      const row = document.createElement('button');
      row.textContent = `${s.data.name}  \u2014  ${s.meta.slug}`;
      Object.assign(row.style, {
        textAlign: 'left',
        padding: '8px 10px',
        background: '#221634', color: '#eee',
        border: '1px solid #444', borderRadius: '4px',
        cursor: 'pointer', font: 'inherit',
      } as Partial<CSSStyleDeclaration>);
      row.addEventListener('click', () => {
        shell.close();
        opts.onPick(s);
      });
      list.appendChild(row);
    }
  }
  shell.panel.appendChild(list);

  const buttons = document.createElement('div');
  Object.assign(buttons.style, { display: 'flex', gap: '8px', justifyContent: 'flex-end' } as Partial<CSSStyleDeclaration>);
  const closeBtn = document.createElement('button');
  closeBtn.textContent = 'Close';
  styleButton(closeBtn);
  closeBtn.addEventListener('click', shell.close);
  buttons.appendChild(closeBtn);
  shell.panel.appendChild(buttons);

  document.body.appendChild(shell.overlay);
  return { close: shell.close };
}
